<div class="backoffice-tree-header" data-cy="backoffice-tree-header">
    <div class="fixed"></div>
    <div class="backoffice-tree-header-sections">
        <div class="backoffice-tree-header-section path text-ellipsis"
             data-cy="backoffice-tree-header-section">Path</div>
        <div class="backoffice-tree-header-section connections text-ellipsis"
             data-cy="backoffice-tree-header-section">Connections</div>
        <div class="backoffice-tree-header-section pool text-ellipsis"
             data-cy="backoffice-tree-header-section">Pool</div>
    </div>
</div>